'use strict';

var FaresFilterByMarketFactory = function FaresFilterByMarketFactory(DataFilter) {
  function FaresFilterByMarket() {
    DataFilter.call(this, ['fares-chart-mode', 'fares-mode', 'fares-average-mode', 'mapped-fares-mode'], 'class-usage', 2);
  }
  FaresFilterByMarket.prototype = Object.create(DataFilter.prototype);
  FaresFilterByMarket.prototype.filter = function (data, range) {
    range = range[0];
    var market = range.market;
    return DataFilter.prototype.filter(data, [market], 'market');
  };
  return FaresFilterByMarket;
};
FaresFilterByMarketFactory.$inject = ['DataFilterFactory'];
module.exports = FaresFilterByMarketFactory;